import { ContactDataDisplayModelFormGroup } from '../../../../../api/models/ace/xFound/Portal/Core/CAQ/Models/contact-data-display-model';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { StateService } from '@/core/services/state.service';
import { ContactDataDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/contact-data-display-model';
import { AnfrageService } from '@/api/service-index';
import { LoadingAnimationService } from '@/core/services/loading-animation.service';
import { PortalContextService } from '@/core/services/portal-context.service';
import { SectionService } from '@/core/services/section.service';
import { AnfrageNavigationFormComponent, MoveDirection } from '../../../../components/anfrage-navigation-form/anfrage-navigation-form.component';
import { UnfinishedHttpMethodsService } from '@/core/services/unfinished-http-methods.service';
import { GlobalEnumsAceAntragstellungerfolgtfuer } from '../../../../../api/models/ace/xFound/Portal/Core/Entities/global-enums-ace-antragstellungerfolgtfuer';

@Component({
  selector: 'applicant-form-process-step',
  templateUrl: './applicant-form-process-step.component.html',
  styleUrls: ['./applicant-form-process-step.component.scss'],
})
export class ApplicantFormProcessStepComponent extends AnfrageNavigationFormComponent{
  public contactDataProcessStepForm: ContactDataDisplayModelFormGroup;
  public contactData: ContactDataDisplayModel;

  public get formGroup(): FormGroup<any> {
    return this.contactDataProcessStepForm;
  }

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected sectionService: SectionService,
    protected anfrageService: AnfrageService,
    protected stateService: StateService,
    protected portalContextService: PortalContextService,
    protected loadingAnimationService: LoadingAnimationService,
    protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService,
  ) {
      super(sectionService, router, route, portalContextService);

    this.contactData = this.route.snapshot.data.contactData;

    this.contactDataProcessStepForm = ContactDataDisplayModelFormGroup.Instance
    this.contactDataProcessStepForm.patchValue(this.contactData);
  }

  
  
  protected save(shouldSave: boolean, moveDirection: MoveDirection): void {
    this.contactDataProcessStepForm.Antragstellungerfolgtfuer.setValue(GlobalEnumsAceAntragstellungerfolgtfuer.Kontakt)

    if (shouldSave && this.contactDataProcessStepForm.dirty) {
      this.contactData = this.contactDataProcessStepForm.value

      this.contactData.institution = undefined;
      this.contactData.ansprechpartner = undefined;
      this.contactData.vertretungsberechtigter = undefined;
      this.contactData.weitererAnsprechpartner = undefined;
      this.contactData.weitererVertretungsberechtigter = undefined;

      delete this.portalContextService.CurrentAnfrage.contactData;
      this.contactDataProcessStepForm.markAsPristine();
      if (moveDirection != MoveDirection.STAY) {
        if (this.canceledRoute) {
          this.router.navigateByUrl(this.canceledRoute);
        } else {
          this.move(moveDirection);
        }
      }
      
      let subscription = this.anfrageService.apiAnfrageAnfrageIdContactDataPatch({ anfrageId: this.anfrage.id, body: this.contactData })
        .subscribe(() => {
          this.anfrageService.apiAnfrageAnfrageIdContactDataGet({ anfrageId: this.anfrage.id }).subscribe(response => {
            if (response) {
              this.anfrageService.apiAnfrageAnfrageIdValidateGet({ anfrageId: this.anfrage.id }).subscribe(result => {
                this.stateService.ValidationErrors = result;
              })

              if (this.portalContextService.CurrentAnfrage)
                this.portalContextService.CurrentAnfrage.contactData = response;

              this.contactDataProcessStepForm.patchValue(response);
              this.contactDataProcessStepForm.markAsPristine();
            }
          });
        });
      this.loadingAnimationService.showSpinnerUsingSubscription(subscription);
      this.unfinishedHttpMethodsService.addSubscription(subscription);
    } else {
      this.contactDataProcessStepForm.markAsPristine();
      this.move(moveDirection);
    }
  }

}
